import dayjs from "dayjs";
import { Component, useMemo } from "react";
import { FiCheckCircle, FiGift, FiInfo, FiXCircle } from "react-icons/fi";
import { FormattedDate, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import settingsStateToProps from "../../../redux/settingsStateToProps";
import CopyButton from "../../cmp/CopyButton";
import CurrencyNumber from "../../cmp/CurrencyNumber";
import FormGroup from "../../cmp/form/FormGroup";
import ProgressBar from "../../cmp/ProgressBar";

function RenderGiftCardBalance({ balance, initialValue }) {
  return (
    <>
      <div className={"d-flex align-items-center justify-content-between"}>
        <div className={"text-muted"}>
          <FiGift size={24} style={{ strokeWidth: 1 }} />
        </div>
        <div>
          <small className={"text-muted"}>Balance&nbsp;</small>
          <span
            className={`fs-4 ${balance > 0 ? "text-success" : "text-muted"}`}
          >
            <CurrencyNumber value={balance} />
          </span>
        </div>
        {/*/ <CurrencyNumber value={initialValue} />*/}
      </div>
    </>
  );
}

//exact copy for partner-frontend
class RenderUserPayment extends Component {
  render() {
    const { payment_method, payment_details_data, custom_payment_methods } =
      this.props;
    const payment_details_obj =
      payment_details_data && payment_details_data !== "null"
        ? typeof payment_details_data === "object"
          ? payment_details_data
          : JSON.parse(payment_details_data)
        : {};
    switch (payment_method) {
      case "tipalti": {
        return (
          <div>
            <string>Tipalti</string>
          </div>
        );
      }
      case "cash": {
        return (
          <div>
            <strong>Cash</strong>
          </div>
        );
      }
      case "payoneer": {
        const { payoneer_email } = payment_details_obj;
        return (
          <div>
            <strong>Payoneer</strong>
            <div>{payoneer_email}</div>
          </div>
        );
      }
      case "cashapp": {
        const { cash_tag } = payment_details_obj;
        return (
          <div>
            <strong>CashApp</strong>
            <div>{cash_tag}</div>
          </div>
        );
      }
      case "paypal": {
        const { paypal_email } = payment_details_obj;
        return (
          <div>
            <strong>PayPal</strong>
            <div>{paypal_email}</div>
          </div>
        );
      }
      case "bank": {
        const { bank_name, account_number } = payment_details_obj;
        return (
          <div>
            <strong>Bank Transfer</strong>
            <div>
              {bank_name && account_number ? (
                <>
                  {bank_name} {account_number?.replaceAll(/.(?=.{4})/g, "*")}
                </>
              ) : null}
            </div>
          </div>
        );
      }
      case "sepa": {
        const { account_number } = payment_details_obj;
        return (
          <div>
            <strong>SEPA</strong>
            {account_number && (
              <div>
                IBAN - <span>{account_number}</span>
              </div>
            )}
          </div>
        );
      }
      case "cheque": {
        const { pay_to, address } = payment_details_obj;
        return (
          <div>
            <strong>Cheque</strong>
            <div>{pay_to}</div>
            <address>{address}</address>
          </div>
        );
      }
      case "venmo": {
        const { venmo_id } = payment_details_obj;
        return (
          <div>
            <strong>Venmo</strong>
            <div>{venmo_id}</div>
          </div>
        );
      }
      case "upi": {
        const { upi_id } = payment_details_obj;
        return (
          <div>
            <strong>UPI</strong>
            <div>{upi_id}</div>
          </div>
        );
      }
      case "paytm": {
        const { paytm_number } = payment_details_obj;
        return (
          <div>
            <strong>PayTM</strong>
            <div>{paytm_number}</div>
          </div>
        );
      }
      case "mpesa": {
        const { mobile_number } = payment_details_obj;
        return (
          <div>
            <strong>MPESA</strong>
            <div>{mobile_number}</div>
          </div>
        );
      }
      case "discountcoupon": {
        return (
          <div>
            <FormattedMessage id={"Store Discount Coupon"} tagName={"strong"} />
            <RenderCoupon payment_details_obj={payment_details_obj} />
          </div>
        );
      }
      case "storegiftcard": {
        return (
          <div>
            {payment_details_obj?.balance !== undefined &&
            !isNaN(payment_details_obj?.balance) ? (
              <RenderGiftCardBalance
                balance={payment_details_obj.balance}
                initialValue={payment_details_obj.initialValue}
                discountAmount={payment_details_obj.discount_amount}
              />
            ) : null}
            <div
              className={"d-flex align-items-center justify-content-between"}
            >
              {/*<FormattedMessage id={"Store Gift Card"} tagName={"strong"}/>*/}

              {/*{*/}
              {/*    payment_details_obj?.balance*/}
              {/*        && payment_details_obj?.balance !== (payment_details_obj?.discount_amount || payment_details_obj?.value)*/}
              {/*        ? <span><CurrencyNumber value={payment_details_obj.balance} /></span> : null*/}
              {/*}*/}
            </div>
            <RenderCoupon payment_details_obj={payment_details_obj} />
          </div>
        );
      }
      case "bitcoin":
        const { btc } = payment_details_obj;
        return (
          <div>
            <strong>BTC</strong>
            <div>{btc}</div>
          </div>
        );
      case "debitcard": {
        const { cardnumber } = payment_details_obj;
        return (
          <div>
            <strong>Debit Card</strong>
            <div>{cardnumber}</div>
          </div>
        );
      }
      case "mercado_pago": {
        const { email, document_number } = payment_details_obj;
        return (
          <div>
            <strong>Mercado Pago</strong>
            <div>
              {email} - {document_number}
            </div>
          </div>
        );
      }
      case "alipay": {
        const { alipay_id } = payment_details_obj;
        return (
          <div>
            <strong>AliPay</strong>
            <div>{alipay_id}</div>
          </div>
        );
      }
      case "wechat": {
        const { wechat_id } = payment_details_obj;
        return (
          <div>
            <strong>WeChat</strong>
            <div>{wechat_id}</div>
          </div>
        );
      }
      case "paynow": {
        const { paynow_mobile } = payment_details_obj;
        return (
          <div>
            <strong>PayNow</strong>
            <div>{paynow_mobile}</div>
          </div>
        );
      }
      case "bkash": {
        const { bkash_mobile } = payment_details_obj;
        return (
          <div>
            <strong>BKash</strong>
            <div>{bkash_mobile}</div>
          </div>
        );
      }
      case "payquicker":
        const { payquicker_email, payquicker_unique_key } = payment_details_obj;
        return (
          <div>
            <strong>PayQuicker</strong>
            <div>
              {payquicker_email}
              <br />
              {payquicker_unique_key}
            </div>
          </div>
        );
      case "hyperwallet": {
        const { usrToken, status } = payment_details_obj;
        return (
          <div>
            <strong>Hyperwallet</strong>
            <div>
              {usrToken ? <RenderHyperwalletStatus status={status} /> : null}
            </div>
          </div>
        );
      }
    }

    const custom_payment =
      custom_payment_methods &&
      custom_payment_methods.find(
        (item) => item.payment_method_id === payment_method
      );
    if (custom_payment) {
      return (
        <div>
          <strong>{custom_payment.title}</strong>
          <RenderCoupon payment_details_obj={payment_details_obj} />
          {custom_payment?.form?.map((item) => {
            return (
              <FormGroup key={item.id}>
                <small>{item.label}</small>
                <div>{payment_details_obj[item.id]}</div>
              </FormGroup>
            );
          })}
        </div>
      );
    } else {
      return null;
      //return <span className={'text-danger'}>-</span>
    }
  }
}

function RenderHyperwalletStatus({ status }) {
  switch (status) {
      case "OPEN":
          return (
              <span className={"d-inline-flex align-items-center text-success"}>
          <FiCheckCircle className={"mr-2"} /> Open
        </span>
          );
    case "ACTIVATED":
      return (
        <span className={"d-inline-flex align-items-center text-success"}>
          <FiCheckCircle className={"mr-2"} /> Active
        </span>
      );
      case "PRE_ACTIVATION":
          return (
              <span className={"d-inline-flex align-items-center text-warning"}>
          <FiInfo className={"mr-2"} /> Pre-activation
        </span>
          );
    case "PRE_ACTIVATED":
      return (
        <span className={"d-inline-flex align-items-center text-warning"}>
          <FiInfo className={"mr-2"} /> Pre-activated
        </span>
      );
      case "CLOSED":
          return (
              <span className={"d-inline-flex align-items-center text-danger"}>
          <FiXCircle className={"mr-2"} /> Closed
        </span>
          );
    case "DE_ACTIVATED":
      return (
        <span className={"d-inline-flex align-items-center text-danger"}>
          <FiXCircle className={"mr-2"} /> Deactivated
        </span>
      );
    case "LOCKED":
      return (
        <span className={"d-inline-flex align-items-center text-danger"}>
          <FiXCircle className={"mr-2"} /> Locked
        </span>
      );
    case "FROZEN":
      return (
        <span className={"d-inline-flex align-items-center text-danger"}>
          <FiXCircle className={"mr-2"} /> Frozen
        </span>
      );
    default:
        return (
            <span className={"d-inline-flex align-items-center"}>
          <FiInfo className={"mr-2"} /> {status}
        </span>
        );
  }
}

export function RenderCoupon({ payment_details_obj }) {
  const c = useMemo(() => {
    return payment_details_obj
      ? payment_details_obj.coupon || payment_details_obj.code
      : null;
  }, [payment_details_obj]);
  if (!c) {
    return null;
  }

  const balance = payment_details_obj?.balance;
  const ends_at = payment_details_obj?.coupon_data?.ends_at;
  const hasExpired = ends_at && new Date(ends_at) < new Date();
  const is_used = hasExpired || payment_details_obj?.is_coupon_used;
  const initialValue = payment_details_obj?.initialValue;
  if (is_used) {
    return (
      <div
        title={"Coupon code is used"}
        style={{
          border: "1px dashed",
          opacity: 0.5,
          textDecoration: "line-through",
          width: "100%",
          letterSpacing: 2,
          fontSize: c.length > 12 ? 22 : 24,
        }}
        className={
          "d-block text-center rounded bg-light-subtle py-2 text-monospace mt-2"
        }
      >
        {c.toUpperCase()}
      </div>
    );
  }
  return (
    <div>
      <div
        className={
          "rounded bg-light-subtle   overflow-hidden border-secondary position-relative mt-2"
        }
        style={{ border: "1px dashed", width: "100%" }}
      >
        <CopyButton
          className={"d-block text-center  py-2 text-monospace"}
          style={{
            width: "100%",
            letterSpacing: 2,
            fontSize: c.length > 12 ? 22 : 24,
          }}
          title={c.toUpperCase()}
          text={c}
        />
          {balance && initialValue ? (
              <div style={{ position: "absolute", bottom: -8, left: 4, right: 4 }}>
                  <ProgressBar max={initialValue} height={12} current={balance || 0} />
              </div>
          ) : null}
      </div>
      {ends_at ? (
        <div
          className={"text-center text-muted"}
          style={{
            fontSize: 14,
          }}
        >
          Valid Until :{" "}
          <FormattedDate
            value={YYYYMMDD(ends_at)}
            month={"short"}
            year={"numeric"}
            day={"numeric"}
          />
        </div>

      ) : null}


    </div>
  );
}

function YYYYMMDD(dateStr) {
  const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    const [, year, month, day] = match;
    console.log({ year, month, day });
    return dayjs(`${year}-${month}-${day}`).toString();
    // Output: { year: '2025', month: '11', day: '30' }
  }
  return dateStr;
}

export default connect(settingsStateToProps(["custom_payment_methods"]))(
  RenderUserPayment
);
